import { mockArticleDetail } from '../mock/article'

class ArticleDao {
  /**
   * 获取文章详情
   * @param {string} id 文章ID
   * @returns {Promise} 返回文章详情数据
   */
  static async getArticleDetail (id) {
    // TODO: 后续替换为真实的API调用
    return new Promise((resolve) => {
      try {
        // 同步获取文章内容
        const article = mockArticleDetail(id)

        setTimeout(() => {
          resolve({
            code: article ? 200 : 404,
            message: article ? 'success' : 'article not found',
            data: article
          })
        }, 200) // 模拟网络延迟
      } catch (error) {
        console.error('获取文章详情失败:', error)
        resolve({
          code: 500,
          message: '获取文章详情失败',
          data: null
        })
      }
    })
  }
}

export default ArticleDao
